import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { affiliate, contactUs } from "../../service/contact";

const initialState = {
  contactUs: [],
  affiliate: [],
  error: "",
};

export const fetchContact = createAsyncThunk(
  "fetchContact/fetchContact",
  async (action) => {
    switch (action.condition) {
      case "contactUs":
        const responseContact = await contactUs(action.payload);
        return responseContact;
      case "affiliate":
        const responseaffiliate = await affiliate(action.payload);
        return responseaffiliate;
      default:
        throw new Error("Invalid condition");
    }
  }
);

export const contactSlice = createSlice({
  name: "fetchContact",
  initialState,
  reducers: {
    clearData: (state) => {
      state.error = "";
      state.success = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchContact.fulfilled, (state, action) => {
        state.status = "succeeded";
        switch (action.payload.API_Name) {
          case "contactUs":
            state.contactUs = action.payload.response.data;
            return state;
          case "affiliate":
            state.affiliate = action.payload.response.data;
            return state;
          default:
            break;
        }
      })
      .addCase(fetchContact.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchContact.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const { clearData } = contactSlice.actions;

export default contactSlice.reducer;
